document.addEventListener("DOMContentLoaded", async () => {
  if (window.__wishlist_loaded__) return; // Mehrfachausführung verhindern
  window.__wishlist_loaded__ = true;

  const container = document.getElementById("wishlist-products");
  const countEl = document.getElementById("wishlist-count");
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  function updateCount() {
    countEl.textContent = `${wishlist.length} ARTIKEL`;
  }

  function renderEmptyMessage() {
    container.innerHTML = `
      <div>
        <p>Du hast noch keine Favoriten gespeichert.</p>
        <a href="/" style="display: inline-block; margin-top: 20px; padding: 12px 24px; border: 1px solid black; text-transform: uppercase; font-size: 14px; text-decoration: none; color: black;">
          NAHA Entdecken
        </a>
      </div>
    `;
  }

  if (!wishlist || wishlist.length === 0) {
    renderEmptyMessage();
    updateCount();
    return;
  }

  updateCount();

  try {
    const responses = await Promise.all(
      wishlist.map(handle =>
        fetch(`/products/${handle}.js`)
          .then(res => res.ok ? res.json() : null)
          .catch(() => null)
      )
    );

    responses.forEach(product => {
      if (!product || !product.variants || product.variants.length === 0) return;

      const image = product.featured_image || 'https://via.placeholder.com/600x800?text=Kein+Bild';
      const variantOptions = product.variants
        .filter(v => v.available)
        .map(
          v => `<option value="${v.id}">${v.public_title || "Standard"}</option>`
        )
        .join("");

      const firstAvailable = product.variants.some(v => v.available);

      const productEL = document.createElement("div");
      productEL.classList.add("wishlist-item");

      productEL.innerHTML = `
        <div style="position: relative;">
          <a href="/products/${product.handle}">
            <img src="${image}" alt="${product.title}" loading="lazy" />
          </a>
          <button class="wishlist-icon-wrapper active" data-handle="${product.handle}" title="Favorit">
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" height="20" width="20">
              <path d="M14.747 2.253a4.278 4.278 0 0 0-6.05 0L8 2.949l-.698-.696a4.278 4.278 0 0 0-6.05 6.05L8 15.05l6.747-6.747a4.278 4.278 0 0 0 0-6.05Z"></path>
            </svg>
          </button>
        </div>
        <p class="wishlist-title-text">${product.title}</p>
        <p class="wishlist-price">${(product.price / 100).toFixed(2)} €</p>

        <details style="margin: 10px 0;">
          <summary style="cursor: pointer; padding: 6px 12px; border: 1px solid black; font-size: 12px; background: white; text-transform: uppercase;">
            Größe wählen
          </summary>
          <select class="wishlist-variant-select" style="width: 100%; margin-top: 10px; padding: 6px; font-size: 12px;">
            ${variantOptions}
          </select>
        </details>

        ${
          firstAvailable
            ? `<button class="wishlist-add-button" style="margin-top: 10px;">Hinzufügen</button>`
            : `<button class="wishlist-add-button" disabled style="margin-top: 10px; opacity: 0.6;">Ausverkauft</button>`
        }
      `;

      container.appendChild(productEL);
    });
  } catch (error) {
    container.innerHTML = "<p>Fehler beim Laden der Favoriten.</p>";
  }

  // Entfernen durch Klick auf Herz
  container.addEventListener("click", function (e) {
    const btn = e.target.closest(".wishlist-icon-wrapper");
    if (btn) {
      const handle = btn.dataset.handle;
      wishlist = wishlist.filter(item => item !== handle);
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
      btn.closest(".wishlist-item").remove();
      updateCount();
      if (wishlist.length === 0) renderEmptyMessage();
      document.dispatchEvent(new CustomEvent("wishlist:update"));
    }
  });

  // Hinzufügen zum Warenkorb
  container.addEventListener("click", async (e) => {
    if (e.target.classList.contains("wishlist-add-button") && !e.target.disabled) {
      const wrapper = e.target.closest(".wishlist-item");
      const select = wrapper.querySelector(".wishlist-variant-select");
      const variantId = select?.value;
      if (!variantId) return;

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
        });

        if (res.ok) {
          e.target.textContent = "Hinzugefügt ✓";
          e.target.disabled = true;

          // Drawer öffnen (Prestige Theme)
          if (window.Shopify && window.Shopify.designMode !== true) {
            document.querySelector("cart-drawer")?.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          }
        } else {
          throw new Error();
        }
      } catch (err) {
        alert("Konnte nicht zum Warenkorb hinzugefügt werden.");
      }
    }
  });
});

